import React, {useEffect, useState} from 'react';
import { getPageSeo } from '../../utilities/functions/magnoliaUtils';
import mockSeoLoaderResponse from '../../utilities/mocks/mockSeoLoaderResponse.json';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SKIP_SEO } from '@/utilities/constants/contentPaths';

function SeoLoader() {
  const [seo, setSeo] = useState({title: null, description: null, keywords: null});

  const location = useLocation();

  useEffect(() => {

    if(SKIP_SEO.some(substring => location.pathname.includes(substring))) return

    async function loadSeo(pagePath: string) {
      let seo: any;
      if (process.env.REACT_APP_MGNL_IS_MOCK === 'true') {
        seo = mockSeoLoaderResponse;
      } else {
        seo = await getPageSeo(pagePath);
      }

      setSeo(seo);
    }

    loadSeo(location.pathname);
  }, [location]);

  return (
    <>
        {seo && seo.title && (
          <HelmetProvider>
            <Helmet>
              <title>{seo.title}</title>
              {seo.description && <meta name='description' content={seo.description} />}
              {seo.keywords && <meta name='keywords' content={seo.keywords} />}
            </Helmet>
          </HelmetProvider>
        )}
    </>
  );
}

export default SeoLoader;
